import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageLinkTabComponent } from './components/page-link-tab/page-link-tab.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { SelectionButtonsComponent } from './components/selection-buttons/selection-buttons.component';

@NgModule({
  declarations: [
    PageLinkTabComponent,
    NavbarComponent,
    SelectionButtonsComponent,
  ],
  imports: [CommonModule],
  exports: [PageLinkTabComponent, NavbarComponent, SelectionButtonsComponent],
})
export class SharedModule {}
